import { useState, useEffect } from "react";
import Axi from "./Axios";
import "./Query.css";

function PageView() {
  const [sumAll, setSumAll] = useState();
  const [today, setToday] = useState();

  async function Query() {
    const data = await Axi();
    //until 20220417 totalUsers:52, totalSessions:77, totalPageViews: 332

    const sumAllPage =
      data.totalsForAllResults[Object.keys(data.totalsForAllResults)[2]];
    setSumAll(332 + sumAllPage * 1);
    const rows = data.rows;
    const toDay = rows[rows.length - 1][0];
    const toDay1 = [
      toDay.slice(0, 4),
      "-",
      toDay.slice(4, 6),
      "-",
      toDay.slice(6),
    ].join("");

    setToday(toDay1);
  }
  useEffect(() => {
    Query();
  }, []);

  return (
    <>
      <div class="All">
        🙊 사람들이 <b>{sumAll}</b>번 다녀갔어요!
      </div>
      <div class="Date">( {today} 기준 )</div>
    </>
  );
}

export default PageView;
